import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './YandexCallback.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const YandexCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      if (errorParam) {
        setError(errorDescription || 'Ошибка авторизации: ' + errorParam);
        setLoading(false);
        return;
      }

      if (!code) {
        setError('Код авторизации не получен');
        setLoading(false);
        return;
      }

      try {
        console.log('🔵 Yandex callback: код получен:', code);
        console.log('🔵 Отправляем запрос на обмен кода...');

        // Обмениваем код на токен
        const response = await fetch(`${API_URL}/auth/oauth/yandex/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ code }),
        });

        console.log('🔵 Response status:', response.status);

        const data = await response.json();
        console.log('🔵 Response data:', data);

        if (!response.ok) {
          throw new Error(data.error || 'Ошибка получения токена');
        }

        // Сохраняем user info для UI (токен хранится в httpOnly cookie)
        localStorage.setItem('user', JSON.stringify(data.user));

        console.log('✅ Авторизация успешна:', data.user);

        // Перенаправляем на главную страницу
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } catch (err: any) {
        console.error('❌ Yandex auth error:', err);
        console.error('❌ Error details:', err.message, err.stack);
        setError('Failed to fetch');
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="yandex-callback-container">
        <div className="callback-content">
          <div className="spinner"></div>
          <h2>Авторизация через Яндекс</h2>
          <p>Пожалуйста, подождите...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="yandex-callback-container">
        <div className="callback-content error">
          <div className="error-icon">⚠️</div>
          <h2>Ошибка авторизации</h2>
          <p className="error-message">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="primary"
          >
            Вернуться на страницу входа
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="yandex-callback-container">
      <div className="callback-content success">
        <div className="success-icon">✓</div>
        <h2>Успешная авторизация</h2>
        <p>Перенаправление...</p>
      </div>
    </div>
  );
};

export default YandexCallback;
